<template>
  <div>
    <div :class="isMobile ? 'news-m' : 'news'" ref="overviewRef01">
      <div class="news-content"> 
        <div class="word">
          <div class="word-title">公司动态</div>
          <div class="word-text">Company Updates</div>
        </div>
        <div v-for="(index) in newsSize" :key="index">
          <div class="content content-left" v-if="index%2===1 || isMobile">
            <div class="imgPart">
              <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url || 'javascript:void(0);'" :target="newsLastArrAll[newsSize*(newsPage-1)+index-1].url ? '_blank':null">
                <img class="bigImg" :src="require(`./../../assets/news/${newsLastArrAll[newsSize*(newsPage-1)+index-1].imgUrl}`)" />
              </a>
            </div>
            <div class="content-word">
              <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url || 'javascript:void(0);'" :target="newsLastArrAll[newsSize*(newsPage-1)+index-1].url ? '_blank':null">
                <div class="title">
                  {{newsLastArrAll[newsSize*(newsPage-1)+index-1].title}}
                  <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url" target="_blank" v-if="newsLastArrAll[newsSize*(newsPage-1)+index-1].url!==''">
                    <i class="el-icon-top-right jumpToOutlink"></i>
                  </a>
                </div>
              
                <div class="date">{{newsLastArrAll[newsSize*(newsPage-1)+index-1].date}}</div>
                <div v-html="newsLastArrAll[newsSize*(newsPage-1)+index-1].text" class="text"></div>
              </a>
            </div>
          </div>
          <div class="content content-right"  v-else>
            <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url || 'javascript:void(0);'" :target="newsLastArrAll[newsSize*(newsPage-1)+index-1].url ? '_blank':null">
              <div class="content-word">
                <div class="title">
                  {{newsLastArrAll[newsSize*(newsPage-1)+index-1].title}}
                  <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url" target="_blank" v-if="newsLastArrAll[newsSize*(newsPage-1)+index-1].url!==''">
                    <i class="el-icon-top-right jumpToOutlink"></i>
                  </a>
                </div>
                <div class="date">{{newsLastArrAll[newsSize*(newsPage-1)+index-1].date}}</div>
                <div v-html="newsLastArrAll[newsSize*(newsPage-1)+index-1].text" class="text"></div>
              </div>
            </a>
            <div class="imgPart">
              <a :href="newsLastArrAll[newsSize*(newsPage-1)+index-1].url || 'javascript:void(0);'" :target="newsLastArrAll[newsSize*(newsPage-1)+index-1].url ? '_blank':null">
                <img class="bigImg" :src="require(`./../../assets/news/${newsLastArrAll[newsSize*(newsPage-1)+index-1].imgUrl}`)" />
              </a>
            </div>
          </div>
        </div>
        <div class="page" ref="overviewRef02"> 
          <el-pagination
            layout="prev, pager, next"
            @current-change="newsPageChange"
            :page-size="newsSize"
            :total="newsLastArrAll.length">
          </el-pagination>
          <span class="total">共{{Math.ceil(newsLastArrAll.length/newsSize)}}页</span>
        </div>
        <div class="word" >
          <div class="word-title">行业方案</div>
          <div class="word-text">Industry Solutions</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="isMobile?24:8" v-for="(index) in currentSize" :key="index+100" >
            <a :href="newsOldArr[currentSize*(currentPage-1)+index-1].url" :target="newsLastArrAll[newsSize*(newsPage-1)+index-1].url ? '_blank':null">
              <div class="oldNewsList"> 
                <div class="content-old" v-if="(currentSize*(currentPage-1)+index-1)<newsOldArr.length">
                  <div class="imgPart">
                    <img class="bigImg" :src="require(`./../../assets/news/${newsOldArr[currentSize*(currentPage-1)+index-1].imgUrl}`)" />
                  </div>
                  <div class="content-word">
                    <div class="title">
                      {{newsOldArr[currentSize*(currentPage-1)+index-1].title}}
                      <a :href="newsOldArr[currentSize*(currentPage-1)+index-1].url" target="_blank" v-if="newsOldArr[currentSize*(currentPage-1)+index-1].url!==''">
                        <i class="el-icon-top-right jumpToOutlink"></i>
                      </a>
                    </div>
                    <div class="date">{{newsOldArr[currentSize*(currentPage-1)+index-1].date}}</div>
                    <div class="text">{{newsOldArr[currentSize*(currentPage-1)+index-1].text}}</div>
                  </div>
                </div>
              </div>
            </a>
          </el-col>
        </el-row>
        <div class="page" ref="overviewRef03"> 
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="currentSize"
            :total="newsOldArr.length">
          </el-pagination>
          <span class="total">共{{Math.ceil(newsOldArr.length/currentSize)}}页</span>
        </div>

        <div class="word">
          <div class="word-title">视频速览</div>
          <div class="word-text">Video Overview</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="isMobile?24:8" v-for="(index) in videoCutPageSize" :key="index+100" >
            <div class="videolist" v-if="videoCutPageSize*(videoCutPage-1)+index<=videolist.length"> 
              <div class="content">
                <div class="video-one">
                  <div class="bigImg">
                    <Video :videoUrl="videolist[videoCutPageSize*(videoCutPage-1)+index-1].videoUrl" :bgUrl="videolist[videoCutPageSize*(videoCutPage-1)+index-1].coverImg"></Video>
                  </div>
                </div>
                <div class="video-word">
                  <div class="title">{{videolist[videoCutPageSize*(videoCutPage-1)+index-1].title}}</div>
                  <div class="text">{{videolist[videoCutPageSize*(videoCutPage-1)+index-1].content}}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="page"> 
          <el-pagination
            layout="prev, pager, next"
            @current-change="videoCutPageChange"
            :page-size="videoCutPageSize"
            :total="videolist.length">
          </el-pagination>
          <span class="total">共{{Math.ceil(videolist.length/videoCutPageSize)}}页</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import arrJson from '@/utils/arrJson';
import Video from '@/components/video.vue'

export default {
  name: 'News',
  components: {
    Video,
  },
  data() {
    return {
      isMobile: window.innerWidth < 780,
      newsLastArrAll: arrJson.lastNews,
      newsOldArr: arrJson.oldNews,
      videolist: arrJson.videolist,
      currentPage: 1,
      currentSize: 6,
      newsPage: 1,
      newsSize: 2,
      videoCutPage: 1,
      videoCutPageSize: 6,
    }
  },
  methods: {
    initOverReview(){
      const overviewRefId = window.sessionStorage.getItem('overviewRefId');
      if(overviewRefId && overviewRefId>=0){
        const overviewlist = [
          this.$refs.overviewRef01,
          this.$refs.overviewRef02,
          this.$refs.overviewRef03
        ]
        const element = overviewlist[overviewRefId]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
        window.sessionStorage.removeItem("overviewRefId")
      }
    },
    handleCurrentChange(page){
      this.currentPage = page
    },
    videoCutPageChange(page){
      this.videoCutPage = page
    },
    newsPageChange(page){
      this.newsPage = page
      console.log("page", page, this.newsLastArrAll[this.newsSize*(this.newsPage-1)], this.newsLastArrAll[this.newsSize*(this.newsPage-1)+1])

    },
    // enterDetail(obj) {
    //   console.log("obj", obj)
    //   this.$router.push({ path: '/newsDetail/'+obj.id })
    // },
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  },
  props: {
    msg: String
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
    const that = this
    setTimeout(() => {
      that.initOverReview()
    }, 0)
    console.log("newsOldArr.length", this.newsOldArr.length, "currentSize", this.currentSize, Math.ceil(this.newsOldArr.length/this.currentSize))
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  }
}
</script>


<style scoped lang="less">
  .news{
    // background: #f5f6fa;
    .news-content{
      max-width: 1400px;
      margin: 40px auto;
      text-align: center;
      .word{
        .word-title{
          line-height: 44px;
          font-size: 32px;
          margin-top: 60px;
          font-weight: bold;
          text-align: center;
          color: #313E47;
        }
        .word-text{
          color: #313E47;
          font-size: 16px;
          line-height: 26px;
          font-weight: normal;
          text-align: center;
          margin-bottom: 30px;
        }
      }
      .content{
       text-align: left;
       margin-bottom: 60px;
        .imgPart{
          display: inline-block;
          width: 30%;
          vertical-align: middle;
          .bigImg{
            width: 100%;
            max-height: 300px;
            display: block;
            border-radius: 10px;
          }
        }
        .content-word{
          display: inline-block;
          width: 60%;
          vertical-align: middle;
          background: #f4f3f3;
          border: 1px solid #d3d3d5;
          padding: 2% 3.6% 2.8% 2.6%;
          .date{
            color: #8d8d8d;
            font-size: 16px;
            line-height: 34px;
            display: inline-block;
            width: 20%;
          }
          .title{
            color: #292929;
            font-size: 21px;
            line-height: 34px;
            display: inline-block;
            font-weight: bold;
            width: 80%;
            margin-bottom: 10px;
          }
          .text{
            color: #636363;
            font-size: 15px;
            line-height: 26px;
            text-align: left;
            // text-indent: 32px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .content-left{
        .content-word{
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
          text-align: left;
          border-left: none;
        }
        .date{
          text-align: right;
        }
      }
      .content-right{
        .content-word{
          border-bottom-left-radius: 10px;
          border-top-left-radius: 10px;
          // text-align: right;
          border-right: none;
        }
        .title{
          text-align: left;
        }
      }
      // .seeMore{
      //   text-align: center;
      //   padding-bottom: 40px;
      //   border-bottom: 1px solid #e3e3e3;
      //   .seeMoreBtn{
      //     font-size: 16px;
      //     color: #0089fe;
      //     border: 1px solid #0089fe;
      //     padding: 14px 40px;
      //     display: inline-block;
      //     margin: 50px auto 0;
      //     cursor: pointer;
      //   }
      // }
      .oldNewsList{
        text-align: left;
        margin-bottom: 60px;
        .content-old{
          padding: 40px;
          box-shadow: 0px 4px 10px #00000030;
        }
        .imgPart{
          // display: inline-block;
          // width: 20%;
          vertical-align: middle;
          .bigImg{
            width: 100%;
            max-height: 300px;
            display: block;
            border-radius: 10px;
          }
        }
        .content-word{
          // display: inline-block;
          // width: 78%;
          vertical-align: top;
          padding: 0 0 0 2%;
          .date{
            color: #696969;
            font-size: 18px;
            line-height: 34px;
            display: inline-block;
            // width: 20%;
            text-align: right;
          }
          .title{
            color: #000000;
            font-size: 18px;
            line-height: 33px;
            margin-top: 20px;
            display: inline-block;
            height: 80px;
            overflow: hidden;
          }
          .text{
            color: #989898;
            font-size: 15px;
            line-height: 26px;
            text-align: left;
            // text-indent: 32px;
            white-space: nowrap;      /* 不换行 */
            overflow: hidden;         /* 隐藏溢出内容 */
            text-overflow: ellipsis;  /* 显示省略号 */
            width: 100%;  
          }
        }
      }
      .videolist{
        text-align: left;
        margin-bottom: 60px;
        .video-one{
          padding: 40px 40px 0;
        }
        .bigImg{
          width: 100%;
          display: block;
          border-radius: 10px;
        }
        .video-word{
          text-align: center;
          vertical-align: top;
          padding: 0 0 0 2%;
          .title{
            color: #000000;
            font-size: 18px;
            line-height: 33px;
            margin-top: 20px;
            display: inline-block;
            font-weight: bold;
          }
          .text{
            color: #989898;
            font-size: 15px;
            line-height: 26px;
            white-space: nowrap;      /* 不换行 */
            overflow: hidden;         /* 隐藏溢出内容 */
            text-overflow: ellipsis;  /* 显示省略号 */
            width: 100%;  
          }
        }
      }
      .page{
        display: inline-block;
        border: 1px solid #f0f0f0;
        margin: 20px 0 0px;
        padding: 2px 16px 2px 6px;
        /deep/ .el-pagination{
          display: inline-block;
          .btn-next{
            background: unset;
          }
          .btn-prev{
            background: unset;
          }
          li{
            background: unset;
            min-width: 24px;
            height: 24px;
            line-height: 24px;
            margin: 2px 8px;
          }
          li.active{
            background: #00D0FF;
            border-radius: 50%;
            color: #fff;
          }
        }
        .total{
          margin-left: 20px;
          line-height: 36px;
        }
      }
    }
  }

  .news-m{
    background: #f5f6fa;
    .news-content{
      margin: 0 0.2rem;
      text-align: center;
      padding: 0.4rem 0;
      .word{
        .word-title{
          font-size: 0.6rem;
          line-height: 1.2rem;
          text-align: center;
        }
        .word-text{
          line-height: 0.6rem;
          color: #9b9b9b;
          font-size: 0.4rem;
          text-align: center;
        }
      }
      .content{
       text-align: left;
       margin-bottom: 0.6rem;
        .imgPart{
          display: inline-block;
          width: 70%;
          vertical-align: middle;
          .bigImg{
            // width: 100%;
            height: 5rem;
            display: block;
            border-radius: 10px;
          }
        }
        .content-word{
          display: inline-block;
          // width: 100%;
          vertical-align: middle;
          background: #f3f3f3;
          border: 0.02rem solid #d3d3d5;
          padding: 2% 3.6% 2.8% 2.6%;
          .date{
            color: #8d8d8d;
            font-size: 0.4rem;
            line-height: 0.7rem;
            display: inline-block;
            width: 35%;
          }
          .title{
            color: #292929;
            font-size: 0.44rem;
            line-height: 0.7rem;
            display: inline-block;
            font-weight: bold;
            width: 65%;
            margin-bottom: 0.2rem;
          }
          .text{
            color: #636363;
            font-size: 0.38rem;
            line-height: 0.7rem;
            text-align: left;
            // text-indent: 0.7rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .content-left{
        .content-word{
          border-radius: 0.3rem;
          text-align: left;
        }
        .date{
          text-align: right;
        }
      }
      .content-right{
        .content-word{
          border-radius: 0.3rem;
          // text-align: right;
        }
        .title{
          text-align: left;
        }
      }
      // .seeMore{
      //   text-align: center;
      //   border-bottom: 1px solid #e3e3e3;
      //   margin-bottom: 0.4rem;
      //   .seeMoreBtn{
      //     font-size: 0.36rem;
      //     color: #0089fe;
      //     border: 0.02rem solid #0089fe;
      //     padding: 0.3rem 0.8rem;
      //     display: inline-block;
      //     margin: 0.2rem auto 0.8rem;
      //   }
      // }
      .oldNewsList{
        text-align: left;
        margin-bottom: 1.2rem;
        .imgPart{
          display: inline-block;
          width: 20%;
          vertical-align: middle;
          .bigImg{
            width: 100%;
            height: 1.8rem;
            display: block;
            border-radius: 0.24rem;
          }
        }
        .content-word{
          display: inline-block;
          width: 74%;
          vertical-align: top;
          padding: 0 0 0 2%;
          .date{
            color: #696969;
            font-size: 0.36rem;
            line-height: 0.7rem;
            text-align: right;
          }
          .title{
            color: #000000;
            font-size: 0.44rem;
            line-height: 0.7rem;
            display: inline-block;
          }
          .text{
            color: #636363;
            font-size: 0.38rem;
            line-height: 0.74rem;
            border-top: 0.02rem #cccdd1 solid;
            padding-top: 0.3rem;
            text-align: left;
            text-indent: 0.8rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .page{
        display: inline-block;
        border: 0.02rem solid #cccdd1;
        margin: 0.5rem 0 1.3rem;
        padding: 0.05rem 0.4rem 0.04rem 0.15rem;
        font-size: 0.36rem;
        line-height: 0.8rem;
        /deep/ .el-pagination{
          display: inline-block;
          .btn-next{
            background: unset;
            font-size: 0.4rem;
            height: 0.8rem;
            line-height: 0.8rem;
          }
          .btn-prev{
            background: unset;
            font-size: 0.4rem;
            height: 0.8rem;
            line-height: 0.8rem;
          }
          li{
            background: unset;
            font-size: 0.3rem;
            height: 0.8rem;
            line-height: 0.8rem;
          }
        }
      }
      .videolist{
        .video-word{
          margin-bottom: 1rem;
          .title{
            font-size: 0.4rem;
            line-height: 0.8rem;
            text-align: center;
          }
          .text{
            font-size: 0.32rem;
            text-align: center;
          }
        }
      }
    }
  }


</style>
